/* eslint-disable */
import DestinationSearchFieldView from "@/js/desktop/View/destination/DestinationSearchFieldView";
import DestinationModel from '@/js/desktop/View/destination/DestinationModel';
import DestinationView from '@/js/desktop/View/destination/Destination';

let DestinationSearchFieldViewExtend = DestinationSearchFieldView.extend({
	placeholder:'Курорт или отель'
});

let DestinationModelExtend = DestinationModel.extend({
	computeds: _.extend({}, DestinationModel.prototype.computeds, {
		label: function() {
			var selectedHotels = this.get('selectedHotels'),
				selectedResorts = this.get('selectedResorts'),
				selectedCountry = this.get('selectedCountry'),
				label = '';

			if(selectedHotels) {
				if(selectedHotels.length == 1) {
					label = selectedHotels.at(0).get('name');
				} else {
					label = selectedHotels.length + ' отел' + selectedHotels.length.wordEnding('ь;я;ей');
				}
			} else if(selectedResorts) {
				if(selectedResorts.length == 1) {
					label = selectedResorts.at(0).get('name');
				} else {
					label = selectedResorts.length + ' курорт' + selectedResorts.length.wordEnding(';а;ов');
				}
			} else if(selectedCountry) {
				label = 'Все курорты';
			}

			return label;
		}
	})
});

let DestinationViewRussia = DestinationView.extend({
	destinationLabel: 'Курорт или отель',
	getDestinationSearchFieldView() {
		return DestinationSearchFieldViewExtend;
	},
	getDestinationModel() {
		return DestinationModelExtend;
	},
	getOptionsList:function(callback) {
		var inputValue = this.model.get('inputString'),
			self = this,
			countryResorts,
			selectedResorts = this.model.get('selectedResorts'),
			selectedCountry = this.model.get('selectedCountry'),
			selectedHotels = this.model.get('selectedHotels'),
			originalLabelChanged = this.model.get('originalLabelChanged'),
			sortCountryResorts = function(resorts) {
				return resorts.sortBy(function(resort){
					var resortsSelected = selectedResorts ? selectedResorts.contains(resort) : 0;
					return ((!resortsSelected*1).toString() + (!resort.get('isPopular')*1).toString() + resort.get('name')).toLowerCase();
				})
			};

		if(inputValue == "" && (selectedCountry || selectedResorts || selectedHotels)) {
			selectedCountry = selectedCountry ? selectedCountry.at(0) : false;

			if(selectedResorts || selectedHotels) {
				selectedCountry = selectedResorts ? selectedResorts.at(0).get('country') : selectedHotels.at(0).get('country');
			}

			if(selectedCountry) {

				countryResorts = sortCountryResorts(selectedCountry.get('resorts'));
				callback({
					value: countryResorts,
					context: {
						showPopularLabels: true,
						resortsListWithFirstAll: true
					}
				});
			}
		} else {
			if (!originalLabelChanged && (selectedCountry || selectedResorts)) {
				selectedCountry = selectedCountry ? selectedCountry.at(0) : selectedResorts.at(0).get('country');

				self.model.set('optionsList', [], {showPopularLabels: true, resortsListWithFirstAll: true});
				selectedCountry.getResorts({
					success: function (countryResorts) {
						countryResorts = sortCountryResorts(countryResorts);
						callback({
							value: countryResorts,
							context: {
								showPopularLabels: true,
								resortsListWithFirstAll: true
							}
						});
					}
				});
			} else if (!originalLabelChanged && selectedHotels) {
				callback({
					value: selectedHotels.models,
					context: {
						showPopularLabels: false
					}
				});
			}
		}
	}
});

export default DestinationViewRussia;

